module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/logo-7fb9b5c9c7f163f6096194c4a56e2244.svg";